/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WithdrawalsIndexRouteImport } from './routes/withdrawals/index'
import { Route as WebhooksIndexRouteImport } from './routes/webhooks/index'
import { Route as TransactionsIndexRouteImport } from './routes/transactions/index'
import { Route as SmsRelayIndexRouteImport } from './routes/sms-relay/index'
import { Route as SmsLogsIndexRouteImport } from './routes/sms-logs/index'
import { Route as SimsIndexRouteImport } from './routes/sims/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SecurityIndexRouteImport } from './routes/security/index'
import { Route as OrdersIndexRouteImport } from './routes/orders/index'
import { Route as MerchantsIndexRouteImport } from './routes/merchants/index'
import { Route as FraudIndexRouteImport } from './routes/fraud/index'
import { Route as DevicesIndexRouteImport } from './routes/devices/index'
import { Route as CommissionsIndexRouteImport } from './routes/commissions/index'
import { Route as CommissionIndexRouteImport } from './routes/commission/index'
import { Route as AuditLogsIndexRouteImport } from './routes/audit-logs/index'
import { Route as ApiAccessIndexRouteImport } from './routes/api-access/index'
import { Route as AnalyticsIndexRouteImport } from './routes/analytics/index'
import { Route as AgentsIndexRouteImport } from './routes/agents/index'
import { Route as AdminUsersIndexRouteImport } from './routes/admin-users/index'
import { Route as MerchantsCreateRouteImport } from './routes/merchants/create'
import { Route as DemoTanstackQueryRouteImport } from './routes/demo/tanstack-query'
import { Route as DemoTableRouteImport } from './routes/demo/table'
import { Route as SimsRegisterIndexRouteImport } from './routes/sims/register/index'
import { Route as SimsMySimsIndexRouteImport } from './routes/sims/my-sims/index'
import { Route as AgentsIdIndexRouteImport } from './routes/agents/$id/index'
import { Route as AgentsIdSimsIndexRouteImport } from './routes/agents/$id/sims/index'
import { Route as AgentsIdEditIndexRouteImport } from './routes/agents/$id/edit/index'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WithdrawalsIndexRoute = WithdrawalsIndexRouteImport.update({
  id: '/withdrawals/',
  path: '/withdrawals/',
  getParentRoute: () => rootRouteImport,
} as any)
const WebhooksIndexRoute = WebhooksIndexRouteImport.update({
  id: '/webhooks/',
  path: '/webhooks/',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsIndexRoute = TransactionsIndexRouteImport.update({
  id: '/transactions/',
  path: '/transactions/',
  getParentRoute: () => rootRouteImport,
} as any)
const SmsRelayIndexRoute = SmsRelayIndexRouteImport.update({
  id: '/sms-relay/',
  path: '/sms-relay/',
  getParentRoute: () => rootRouteImport,
} as any)
const SmsLogsIndexRoute = SmsLogsIndexRouteImport.update({
  id: '/sms-logs/',
  path: '/sms-logs/',
  getParentRoute: () => rootRouteImport,
} as any)
const SimsIndexRoute = SimsIndexRouteImport.update({
  id: '/sims/',
  path: '/sims/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityIndexRoute = SecurityIndexRouteImport.update({
  id: '/security/',
  path: '/security/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsIndexRoute = MerchantsIndexRouteImport.update({
  id: '/merchants/',
  path: '/merchants/',
  getParentRoute: () => rootRouteImport,
} as any)
const FraudIndexRoute = FraudIndexRouteImport.update({
  id: '/fraud/',
  path: '/fraud/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevicesIndexRoute = DevicesIndexRouteImport.update({
  id: '/devices/',
  path: '/devices/',
  getParentRoute: () => rootRouteImport,
} as any)
const CommissionsIndexRoute = CommissionsIndexRouteImport.update({
  id: '/commissions/',
  path: '/commissions/',
  getParentRoute: () => rootRouteImport,
} as any)
const CommissionIndexRoute = CommissionIndexRouteImport.update({
  id: '/commission/',
  path: '/commission/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditLogsIndexRoute = AuditLogsIndexRouteImport.update({
  id: '/audit-logs/',
  path: '/audit-logs/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiAccessIndexRoute = ApiAccessIndexRouteImport.update({
  id: '/api-access/',
  path: '/api-access/',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalyticsIndexRoute = AnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/admin-users/',
  path: '/admin-users/',
  getParentRoute: () => rootRouteImport,
} as any)
const MerchantsCreateRoute = MerchantsCreateRouteImport.update({
  id: '/merchants/create',
  path: '/merchants/create',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoTanstackQueryRoute = DemoTanstackQueryRouteImport.update({
  id: '/demo/tanstack-query',
  path: '/demo/tanstack-query',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoTableRoute = DemoTableRouteImport.update({
  id: '/demo/table',
  path: '/demo/table',
  getParentRoute: () => rootRouteImport,
} as any)
const SimsRegisterIndexRoute = SimsRegisterIndexRouteImport.update({
  id: '/sims/register/',
  path: '/sims/register/',
  getParentRoute: () => rootRouteImport,
} as any)
const SimsMySimsIndexRoute = SimsMySimsIndexRouteImport.update({
  id: '/sims/my-sims/',
  path: '/sims/my-sims/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIdIndexRoute = AgentsIdIndexRouteImport.update({
  id: '/agents/$id/',
  path: '/agents/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIdSimsIndexRoute = AgentsIdSimsIndexRouteImport.update({
  id: '/agents/$id/sims/',
  path: '/agents/$id/sims/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIdEditIndexRoute = AgentsIdEditIndexRouteImport.update({
  id: '/agents/$id/edit/',
  path: '/agents/$id/edit/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/demo/table': typeof DemoTableRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
  '/merchants/create': typeof MerchantsCreateRoute
  '/admin-users': typeof AdminUsersIndexRoute
  '/agents': typeof AgentsIndexRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/api-access': typeof ApiAccessIndexRoute
  '/audit-logs': typeof AuditLogsIndexRoute
  '/commission': typeof CommissionIndexRoute
  '/commissions': typeof CommissionsIndexRoute
  '/devices': typeof DevicesIndexRoute
  '/fraud': typeof FraudIndexRoute
  '/merchants': typeof MerchantsIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/security': typeof SecurityIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/sims': typeof SimsIndexRoute
  '/sms-logs': typeof SmsLogsIndexRoute
  '/sms-relay': typeof SmsRelayIndexRoute
  '/transactions': typeof TransactionsIndexRoute
  '/webhooks': typeof WebhooksIndexRoute
  '/withdrawals': typeof WithdrawalsIndexRoute
  '/agents/$id': typeof AgentsIdIndexRoute
  '/sims/my-sims': typeof SimsMySimsIndexRoute
  '/sims/register': typeof SimsRegisterIndexRoute
  '/agents/$id/edit': typeof AgentsIdEditIndexRoute
  '/agents/$id/sims': typeof AgentsIdSimsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/demo/table': typeof DemoTableRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
  '/merchants/create': typeof MerchantsCreateRoute
  '/admin-users': typeof AdminUsersIndexRoute
  '/agents': typeof AgentsIndexRoute
  '/analytics': typeof AnalyticsIndexRoute
  '/api-access': typeof ApiAccessIndexRoute
  '/audit-logs': typeof AuditLogsIndexRoute
  '/commission': typeof CommissionIndexRoute
  '/commissions': typeof CommissionsIndexRoute
  '/devices': typeof DevicesIndexRoute
  '/fraud': typeof FraudIndexRoute
  '/merchants': typeof MerchantsIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/security': typeof SecurityIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/sims': typeof SimsIndexRoute
  '/sms-logs': typeof SmsLogsIndexRoute
  '/sms-relay': typeof SmsRelayIndexRoute
  '/transactions': typeof TransactionsIndexRoute
  '/webhooks': typeof WebhooksIndexRoute
  '/withdrawals': typeof WithdrawalsIndexRoute
  '/agents/$id': typeof AgentsIdIndexRoute
  '/sims/my-sims': typeof SimsMySimsIndexRoute
  '/sims/register': typeof SimsRegisterIndexRoute
  '/agents/$id/edit': typeof AgentsIdEditIndexRoute
  '/agents/$id/sims': typeof AgentsIdSimsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/demo/table': typeof DemoTableRoute
  '/demo/tanstack-query': typeof DemoTanstackQueryRoute
  '/merchants/create': typeof MerchantsCreateRoute
  '/admin-users/': typeof AdminUsersIndexRoute
  '/agents/': typeof AgentsIndexRoute
  '/analytics/': typeof AnalyticsIndexRoute
  '/api-access/': typeof ApiAccessIndexRoute
  '/audit-logs/': typeof AuditLogsIndexRoute
  '/commission/': typeof CommissionIndexRoute
  '/commissions/': typeof CommissionsIndexRoute
  '/devices/': typeof DevicesIndexRoute
  '/fraud/': typeof FraudIndexRoute
  '/merchants/': typeof MerchantsIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/security/': typeof SecurityIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/sims/': typeof SimsIndexRoute
  '/sms-logs/': typeof SmsLogsIndexRoute
  '/sms-relay/': typeof SmsRelayIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
  '/webhooks/': typeof WebhooksIndexRoute
  '/withdrawals/': typeof WithdrawalsIndexRoute
  '/agents/$id/': typeof AgentsIdIndexRoute
  '/sims/my-sims/': typeof SimsMySimsIndexRoute
  '/sims/register/': typeof SimsRegisterIndexRoute
  '/agents/$id/edit/': typeof AgentsIdEditIndexRoute
  '/agents/$id/sims/': typeof AgentsIdSimsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/demo/table'
    | '/demo/tanstack-query'
    | '/merchants/create'
    | '/admin-users'
    | '/agents'
    | '/analytics'
    | '/api-access'
    | '/audit-logs'
    | '/commission'
    | '/commissions'
    | '/devices'
    | '/fraud'
    | '/merchants'
    | '/orders'
    | '/security'
    | '/settings'
    | '/sims'
    | '/sms-logs'
    | '/sms-relay'
    | '/transactions'
    | '/webhooks'
    | '/withdrawals'
    | '/agents/$id'
    | '/sims/my-sims'
    | '/sims/register'
    | '/agents/$id/edit'
    | '/agents/$id/sims'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/demo/table'
    | '/demo/tanstack-query'
    | '/merchants/create'
    | '/admin-users'
    | '/agents'
    | '/analytics'
    | '/api-access'
    | '/audit-logs'
    | '/commission'
    | '/commissions'
    | '/devices'
    | '/fraud'
    | '/merchants'
    | '/orders'
    | '/security'
    | '/settings'
    | '/sims'
    | '/sms-logs'
    | '/sms-relay'
    | '/transactions'
    | '/webhooks'
    | '/withdrawals'
    | '/agents/$id'
    | '/sims/my-sims'
    | '/sims/register'
    | '/agents/$id/edit'
    | '/agents/$id/sims'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/demo/table'
    | '/demo/tanstack-query'
    | '/merchants/create'
    | '/admin-users/'
    | '/agents/'
    | '/analytics/'
    | '/api-access/'
    | '/audit-logs/'
    | '/commission/'
    | '/commissions/'
    | '/devices/'
    | '/fraud/'
    | '/merchants/'
    | '/orders/'
    | '/security/'
    | '/settings/'
    | '/sims/'
    | '/sms-logs/'
    | '/sms-relay/'
    | '/transactions/'
    | '/webhooks/'
    | '/withdrawals/'
    | '/agents/$id/'
    | '/sims/my-sims/'
    | '/sims/register/'
    | '/agents/$id/edit/'
    | '/agents/$id/sims/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  DemoTableRoute: typeof DemoTableRoute
  DemoTanstackQueryRoute: typeof DemoTanstackQueryRoute
  MerchantsCreateRoute: typeof MerchantsCreateRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute
  ApiAccessIndexRoute: typeof ApiAccessIndexRoute
  AuditLogsIndexRoute: typeof AuditLogsIndexRoute
  CommissionIndexRoute: typeof CommissionIndexRoute
  CommissionsIndexRoute: typeof CommissionsIndexRoute
  DevicesIndexRoute: typeof DevicesIndexRoute
  FraudIndexRoute: typeof FraudIndexRoute
  MerchantsIndexRoute: typeof MerchantsIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  SecurityIndexRoute: typeof SecurityIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SimsIndexRoute: typeof SimsIndexRoute
  SmsLogsIndexRoute: typeof SmsLogsIndexRoute
  SmsRelayIndexRoute: typeof SmsRelayIndexRoute
  TransactionsIndexRoute: typeof TransactionsIndexRoute
  WebhooksIndexRoute: typeof WebhooksIndexRoute
  WithdrawalsIndexRoute: typeof WithdrawalsIndexRoute
  AgentsIdIndexRoute: typeof AgentsIdIndexRoute
  SimsMySimsIndexRoute: typeof SimsMySimsIndexRoute
  SimsRegisterIndexRoute: typeof SimsRegisterIndexRoute
  AgentsIdEditIndexRoute: typeof AgentsIdEditIndexRoute
  AgentsIdSimsIndexRoute: typeof AgentsIdSimsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/withdrawals/': {
      id: '/withdrawals/'
      path: '/withdrawals'
      fullPath: '/withdrawals'
      preLoaderRoute: typeof WithdrawalsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/webhooks/': {
      id: '/webhooks/'
      path: '/webhooks'
      fullPath: '/webhooks'
      preLoaderRoute: typeof WebhooksIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions/': {
      id: '/transactions/'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof TransactionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sms-relay/': {
      id: '/sms-relay/'
      path: '/sms-relay'
      fullPath: '/sms-relay'
      preLoaderRoute: typeof SmsRelayIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sms-logs/': {
      id: '/sms-logs/'
      path: '/sms-logs'
      fullPath: '/sms-logs'
      preLoaderRoute: typeof SmsLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sims/': {
      id: '/sims/'
      path: '/sims'
      fullPath: '/sims'
      preLoaderRoute: typeof SimsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security/': {
      id: '/security/'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/': {
      id: '/merchants/'
      path: '/merchants'
      fullPath: '/merchants'
      preLoaderRoute: typeof MerchantsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fraud/': {
      id: '/fraud/'
      path: '/fraud'
      fullPath: '/fraud'
      preLoaderRoute: typeof FraudIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/devices/': {
      id: '/devices/'
      path: '/devices'
      fullPath: '/devices'
      preLoaderRoute: typeof DevicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/commissions/': {
      id: '/commissions/'
      path: '/commissions'
      fullPath: '/commissions'
      preLoaderRoute: typeof CommissionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/commission/': {
      id: '/commission/'
      path: '/commission'
      fullPath: '/commission'
      preLoaderRoute: typeof CommissionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit-logs/': {
      id: '/audit-logs/'
      path: '/audit-logs'
      fullPath: '/audit-logs'
      preLoaderRoute: typeof AuditLogsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api-access/': {
      id: '/api-access/'
      path: '/api-access'
      fullPath: '/api-access'
      preLoaderRoute: typeof ApiAccessIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/': {
      id: '/agents/'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin-users/': {
      id: '/admin-users/'
      path: '/admin-users'
      fullPath: '/admin-users'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/merchants/create': {
      id: '/merchants/create'
      path: '/merchants/create'
      fullPath: '/merchants/create'
      preLoaderRoute: typeof MerchantsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/tanstack-query': {
      id: '/demo/tanstack-query'
      path: '/demo/tanstack-query'
      fullPath: '/demo/tanstack-query'
      preLoaderRoute: typeof DemoTanstackQueryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/table': {
      id: '/demo/table'
      path: '/demo/table'
      fullPath: '/demo/table'
      preLoaderRoute: typeof DemoTableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sims/register/': {
      id: '/sims/register/'
      path: '/sims/register'
      fullPath: '/sims/register'
      preLoaderRoute: typeof SimsRegisterIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sims/my-sims/': {
      id: '/sims/my-sims/'
      path: '/sims/my-sims'
      fullPath: '/sims/my-sims'
      preLoaderRoute: typeof SimsMySimsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$id/': {
      id: '/agents/$id/'
      path: '/agents/$id'
      fullPath: '/agents/$id'
      preLoaderRoute: typeof AgentsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$id/sims/': {
      id: '/agents/$id/sims/'
      path: '/agents/$id/sims'
      fullPath: '/agents/$id/sims'
      preLoaderRoute: typeof AgentsIdSimsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$id/edit/': {
      id: '/agents/$id/edit/'
      path: '/agents/$id/edit'
      fullPath: '/agents/$id/edit'
      preLoaderRoute: typeof AgentsIdEditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  DemoTableRoute: DemoTableRoute,
  DemoTanstackQueryRoute: DemoTanstackQueryRoute,
  MerchantsCreateRoute: MerchantsCreateRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
  AgentsIndexRoute: AgentsIndexRoute,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  ApiAccessIndexRoute: ApiAccessIndexRoute,
  AuditLogsIndexRoute: AuditLogsIndexRoute,
  CommissionIndexRoute: CommissionIndexRoute,
  CommissionsIndexRoute: CommissionsIndexRoute,
  DevicesIndexRoute: DevicesIndexRoute,
  FraudIndexRoute: FraudIndexRoute,
  MerchantsIndexRoute: MerchantsIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  SecurityIndexRoute: SecurityIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SimsIndexRoute: SimsIndexRoute,
  SmsLogsIndexRoute: SmsLogsIndexRoute,
  SmsRelayIndexRoute: SmsRelayIndexRoute,
  TransactionsIndexRoute: TransactionsIndexRoute,
  WebhooksIndexRoute: WebhooksIndexRoute,
  WithdrawalsIndexRoute: WithdrawalsIndexRoute,
  AgentsIdIndexRoute: AgentsIdIndexRoute,
  SimsMySimsIndexRoute: SimsMySimsIndexRoute,
  SimsRegisterIndexRoute: SimsRegisterIndexRoute,
  AgentsIdEditIndexRoute: AgentsIdEditIndexRoute,
  AgentsIdSimsIndexRoute: AgentsIdSimsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
